import * as React from 'react';
import '../App.css';

import MuiTextField from "material-ui/TextField";
import {TextFieldProps} from "material-ui";

// Possible parameters of the TextField
interface ITextFieldProps {
    className?: string;
    /** style */
    style?: React.CSSProperties;
    /** password field will only show asterics instead of what was typed in */
    password?: boolean;
    /** The content to use for the floating label element. */
    floatingLabelText?: React.ReactNode;
    /** current text */
    value?: string | number;
    /** text field name */
    name?: string;
    /** text shown for the empty TextFieldRegEx */
    placeholder?: string;
    /** property to enable/disable focus */
    disabled?: boolean;
    /** property to enable/disable input */
    readonly?: boolean;
    /** defines if to show underline */
    underlineShow?: boolean;
    /** property to define the input is invalid */
    errorText?: React.ReactNode;
    /** id to make unique identification of component */
    id?: string;
    /** defines the text field to be multiline or not */
    multiLine?: boolean;
    /** rows to display for multiline text fields */
    rows?: number;
    /** max rows to display for multiline text fields */
    rowsMax?: number;
    /** max number of characters allowed */
    maxLength?: number;
    /** flag for permanently updating the value */
    shouldAlwaysUpdate?: boolean;
    inputStyle?: React.CSSProperties;
    textareaStyle?: React.CSSProperties;
    onFocus?(event: React.FocusEvent<{}>, newValue: string): void;
    onBlur?(event: React.FocusEvent<{}>, newValue: string): void;
    onChange?(event: React.FormEvent<{}>, newValue: string): void;
    onKeyDown?(event: React.KeyboardEvent<{}>): any;
    onKeyPress?(event: React.KeyboardEvent<{}>): any;
    onKeyUp?(event: React.KeyboardEvent<{}>): any;
}

interface ITextFieldState {
    value: string; // current text
}

export default class TextField extends React.Component<ITextFieldProps, ITextFieldState>
{
    node: MuiTextField | null;

    constructor(props: ITextFieldProps) {
        super(props);
        this.state =
            {
                value: props.value ? props.value.toString() : "",
            };
        // This binding is necessary to make `this` work in the callback
        this.onChange = this.onChange.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onFocus = this.onFocus.bind(this);
    }

    componentWillReceiveProps(newProps: ITextFieldProps) {
        if (newProps.value !== this.props.value || this.props.shouldAlwaysUpdate) {
            this.setState({value: newProps.value ? newProps.value.toString() : ""});
        }
    }

    onChange(event: React.FormEvent<{}>, newValue: string) {
        if (!this.props.readonly) {
            this.setState({value: this.props.maxLength ? newValue.substring(0, this.props.maxLength) : newValue});

            if (this.props.onChange) {
                this.props.onChange(event, newValue);
            }
        }
    }

    onBlur(event: React.FocusEvent<{}>) {
        if (this.props.onBlur)
            this.props.onBlur(event, this.state.value);
    }

    onFocus(event: React.FocusEvent<{}>) {
        if (this.props.onFocus)
            this.props.onFocus(event, this.state.value);
    }

    blur(): void {
        if (this.node)
            this.node.blur();
    }

    focus(): void {
        if (this.node)
            this.node.focus();
    }

    select(): void {
        if (this.node)
            this.node.select();
    }

    getValue(): string {
        return this.node ? this.node.getValue() : '';
    }

    getInputNode(): HTMLInputElement | null {
        return this.node ? this.node.getInputNode() : null;
    }

    render() {
        // defined the properties of MuiTextField before use
        let tfProps: TextFieldProps =
            {
                type: this.props.password ? "password" : "text",
                name: this.props.name,
                floatingLabelText: this.props.floatingLabelText,
                value: this.state.value,
                hintText: this.props.placeholder,
                disabled: this.props.disabled,
                underlineShow: this.props.underlineShow,
                onChange: this.onChange,
                errorText: this.props.errorText,
                id: this.props.id,
                onBlur: this.props.onBlur ? this.onBlur : undefined,
                onFocus: this.props.onFocus ? this.onFocus : undefined,
                fullWidth: true,
                multiLine: this.props.multiLine,
                rows: this.props.rows,
                rowsMax: this.props.rowsMax,
                onKeyDown: this.props.onKeyDown,
                onKeyPress: this.props.onKeyPress,
                onKeyUp: this.props.onKeyUp,
            };

        let style = {display: 'flex', width: '100%'};
        Object.assign(style, this.props.style);
        return (
            <div style={style} className="text-field-container">
                <MuiTextField
                    inputStyle={this.props.inputStyle}
                    textareaStyle={this.props.textareaStyle}
                    className={this.props.className ? this.props.className + " text-field" : "text-field"}
                    ref={(el) => this.node = el}
                    {...tfProps}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/TextField.tsx